import PropTypes from 'prop-types';

import { ToggleButton } from './ToggleButton'
import { ToggleButtonBox } from './ToggleButtonBox'

import i18n from '@/i18n'
import { useEffect } from 'react'
import { useState, useRef } from 'react'

export function SLToggle({
    checked = false,
    onLabel,
    onClick,
    offLabel,
    disabled,
    readOnly,
    name,
    loading=false,
    ...props
}) {
    return (
        <>
            <ToggleButtonBox sx={{ opacity: disabled || loading || readOnly ? 0.5 : 1, pointerEvents: disabled ? 'none': undefined }} {...props}>
                <ToggleButton
                    active={checked}
                    onClick={onClick}
                >
                    {onLabel ?? i18n.t('on')}
                </ToggleButton>
                <ToggleButton
                    active={!checked}
                    onClick={onClick}
                >
                    {offLabel ?? i18n.t('off')}
                </ToggleButton>
            </ToggleButtonBox>
        </>
    )
}

SLToggle.propTypes = {
    defaultChecked: PropTypes.bool,
    children: PropTypes.node,
    onLabel: PropTypes.string,
    onChange: PropTypes.func,
    offLabel: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    name: PropTypes.string
}